import { render, staticRenderFns } from "./SortSwitch.vue?vue&type=template&id=bcb0fcae&scoped=true"
import script from "./SortSwitch.vue?vue&type=script&lang=js"
export * from "./SortSwitch.vue?vue&type=script&lang=js"
import style0 from "./SortSwitch.vue?vue&type=style&index=0&id=bcb0fcae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb0fcae",
  null
  
)

export default component.exports